import UserContext from "Context/UserProvider";
import { useContext } from "react";
import { displayProductButton } from "utils/productUtils";
import { Button, Icon, Box } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import ShareIcon from '@mui/icons-material/Share';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BoltIcon from '@mui/icons-material/Bolt';
import { useApiService } from "../../../../../services/ApiService/ApiService";

interface ProductSelectorProps {
    businessProducts: string[];
    product: string;
    title: string;
    icon?: string;
}

const ProductSelector: React.FC<ProductSelectorProps> = ({ businessProducts, product, title }) => {
    const { selectedProduct, setSelectedProduct, userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();

    if (!displayProductButton(product, businessProducts)) {
        return null;
    }

    const handleProductChange = async () => {
        try {
            const bodyData = {
                uuid: userInfo.uuid,
                accountUuid: userInfo.accountUuid,
                businessUuid: userInfo.businessUuid,
                productType: product,
            };

            const response = await fetchWithAuth('/user_auth/product/selected/change', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (response.ok) {
                // Only update local state if API call succeeds
                setSelectedProduct(product);
            } else {
                console.error('Failed to update selected product');
            }
        } catch (error) {
            console.error('Error updating selected product:', error);
        }
    };

    const getIcon = () => {
        switch (product) {
            case 'PLAN':
                return <MapIcon />;
            case 'SHARE':
                return <ShareIcon />;
            case 'AGREE':
                return <HandshakeIcon />;
            case 'CHARGE':
                return <BoltIcon />;
            default:
                return null;
        }
    };

    return (
        <Button
            onClick={handleProductChange}
            startIcon={getIcon()}
            disableElevation
            sx={{
                textTransform: 'none',
                minWidth: { xs: 40, md: 88 },
                px: { xs: 1, md: 2 },
                py: 1,
                bgcolor: selectedProduct === product ? 'rgba(190, 242, 19, 0.12)' : 'transparent',
                color: '#BEF213',
                borderRadius: 1,
                boxShadow: 'none',
                '&:hover': {
                    bgcolor: 'rgba(190, 242, 19, 0.08)',
                    boxShadow: 'none',
                },
                '& .MuiButton-startIcon': {
                    marginRight: { xs: 0, md: 1 },
                    marginLeft: { xs: 0, md: -0.5 },
                    '& .MuiSvgIcon-root': {
                        color: '#BEF213',
                        fontSize: { xs: '1.5rem', md: '1.25rem' }
                    }
                },
                zIndex: 1200
            }}
        >
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                {title}
            </Box>
        </Button>
    );
}

export default ProductSelector;
